import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
// import logo from "../../assets/synlian_logo.png";
import { IconChevronRight } from "@tabler/icons-react";
import React, { useState, FC } from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/logo.png";
import { BASE_URL_LANDING_PAGE } from "../../constant/constant";
import { useStyles } from "./Navbar.styles";

interface IProps {
  content?: React.ReactNode;
}

const Navbar: FC<IProps> = (props) => {
  const { content } = props;
  const { classes } = useStyles();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div>
      <header className={classes.header}>
        <nav className={classes.navbar} aria-label="Global">
          <div style={{ display: "flex", padding: "10px" }}>
            {/* Single plain anchor: the old <a href="#"><Link>…</Link></a> nested
                two anchors (invalid HTML, axe: link-name) and react-router's
                <Link> treats the absolute landing-page URL as an internal route
                anyway. The img alt names the link for screen readers. */}
            <a href={BASE_URL_LANDING_PAGE}>
              <img className={classes.logo} src={logo} alt="FundedHere home" />
            </a>
          </div>
        </nav>
      </header>

      {mobileMenuOpen && (
        <Dialog
          as="div"
          className={classes.menu}
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          style={{ zIndex: 9999 }}
        >
          <div className={classes.overlay} onClick={() => setMobileMenuOpen(false)}></div>

          <div className={classes.root}>
            <div className={classes.container}>
              <div style={{ padding: 20 }} className=" p-4">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Link to="/">
                    <img className={classes.logo} src={logo} alt="Company Logo" />
                  </Link>

                  <XMarkIcon
                    className={classes.icon}
                    onClick={() => setMobileMenuOpen(false)}
                    aria-hidden="true"
                  />
                </div>
              </div>
              <div className={classes.menuItem}>
                <Link to="/login" className={classes.menuItem}>
                  <p className={classes.item}>
                    <IconChevronRight style={{ verticalAlign: "middle" }} /> Login
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </Dialog>
      )}
      <div>{content}</div>
    </div>
  );
};

export default Navbar;
